export function searchDebounce(fn, timer = 500) {
    let scheduled

    return function(...arg) {
        clearTimeout(scheduled)

        return scheduled = setTimeout(function() { fn(...arg) }, timer)
    }
}
